import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography, Box, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

// Project imports
import NavItem from '../NavItem'; // Ensure correct path
import NavCollapse from '../NavCollapse'; // Ensure correct path
import NavigationScroll from '@/app/layout/NavigationScroll'; // Ensure correct path
import React from 'react';

const NavGroup = ({ item }) => {
    const theme = useTheme();
    const [isExpanded, setIsExpanded] = React.useState(false);

    const handleToggle = () => {
        setIsExpanded((prev) => !prev);
    };

    const items = item.children?.map((menu) => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            <NavigationScroll>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                    }}
                    onClick={handleToggle}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {item.icon && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginRight: 1,
                                }}
                            >
                                {item.icon}
                            </Box>
                        )}
                        <Typography
                            variant="caption"
                            sx={{ ...theme.typography.menuCaption, textTransform: 'none' }}
                            display="block"
                            gutterBottom
                        >
                            {item.title}
                        </Typography>
                    </Box>
                    <IconButton size="small">
                        {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                </Box>
                {isExpanded && <List>{items}</List>}
                <Divider
                    sx={{
                        borderColor: theme.palette.mode === 'dark' ? 'white' : 'black',
                        marginY: 1,
                    }}
                />
            </NavigationScroll>
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object.isRequired,
};

export default NavGroup;